import React from 'react';
import { Helmet } from 'react-helmet-async';

const DOMAIN = 'https://crownbypreshy.com';
const SITE_NAME = 'Crowns by Preshy';
const DEFAULT_IMAGE = 'https://images.unsplash.com/photo-1662794108473-ee34ffa6370e?w=1200&h=630&fit=crop&crop=top&fm=webp&q=80';

const SEO = ({ title, description, path = '', image, noindex = false }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Premium Hair Styling in Nigeria`;
  const fullUrl = `${DOMAIN}${path}`;
  const ogImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="en_NG" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {noindex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
};

export default SEO;
